export default __webpack_public_path__ + "static/media/smartphoneCircle.d88c8867.png";